// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyCardFinderPatient {
    static getAttributeTypeMap() {
        return PharmacyCardFinderPatient.attributeTypeMap;
    }
}
PharmacyCardFinderPatient.discriminator = undefined;
PharmacyCardFinderPatient.additionalProperties = false;
PharmacyCardFinderPatient.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "birthDate",
        "baseName": "birthDate",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "PharmacyCardFinderGender"
    },
    {
        "name": "zipCode",
        "baseName": "zipCode",
        "type": "string"
    },
    {
        "name": "phone",
        "baseName": "phone",
        "type": "string"
    },
];
//# sourceMappingURL=pharmacyCardFinderPatient.js.map